export const enrollmentForm = {
  title: "Pre-Enrollment Request",
  subtitle: "Complete this form and we will contact you to start the admission process",
  
  contactInfo: "Contact Information",
  parentName: "Full name of parent/guardian",
  email: "Email",
  phone: "Phone",
  
  childrenInfo: "Children Information",
  child: "Child",
  addChild: "Add another child",
  childName: "Child's name",
  birthDate: "Birth date",
  currentSchool: "Current school",
  currentSchoolPlaceholder: "Optional",
  desiredLevel: "Desired level",
  
  levels: {
    infantil: "Infantil (3-5 years)",
    primaryC1: "Primary C1 (6-8 years)",
    primaryC2: "Primary C2 (9-11 years)"
  },
  
  preferences: "Preferences",
  preferredStartDate: "Preferred start date",
  immediate: "Immediate",
  howDidYouHear: "How did you hear about us?",
  
  sources: {
    web: "Website",
    recommendation: "Recommendation",
    socialMedia: "Social media",
    openHouse: "Open house",
    other: "Other"
  },
  
  servicesInterest: "Services of Interest",
  services: {
    transport: "School transport",
    earlyBirds: "Early Birds (8:00-8:45h)",
    lunch: "Lunch"
  },
  
  comments: "Comments or questions",
  commentsPlaceholder: "Tell us any additional information you consider relevant...",
  
  privacyPolicy: "I have read the data protection information",
  
  submit: "Submit Request",
  submitting: "Submitting...",
  
  success: "Request sent successfully! We will contact you soon.",
  error: "Error sending request. Please try again or contact us directly.",

  stepper: {
    steps: {
      contact: "Your details",
      children: "Your children",
      preferences: "Preferences",
      services: "Services",
      review: "Review",
    },
    next: "Continue",
    previous: "Previous",
    stepOf: "Step {current} of {total}",
  },
};